import { Provider } from 'react-redux';
import requester from '@zg-rentals/particles-js-requester';
import { setupGrowthClient } from '@zg-rentals/rental-growth-api';

// components
import PriceMyRental from './PriceMyRental';

// flux
import store from './flux/configureStore';

// constants
import StringConstants from './constants/StringConstants';

// types
import type { AxiosInstance } from 'axios';
import type { PriceMyRentalPropsType } from './PriceMyRental';
import type { ErrorLoggerType, FormatForLogType } from './utils/errors/types';

type PMRWidgetPropsType = PriceMyRentalPropsType & {
  appLogger?: ErrorLoggerType;
  requestClient?: AxiosInstance;
  rentalGrowthClient?: AxiosInstance;
};

if (typeof window !== 'undefined') {
  setupGrowthClient(`${window.location.origin}/${StringConstants.RG_PROXY_PATH.replace(/\/$/, '')}`);
}

let growthRequestClient = requester({
  proxyPath: StringConstants.RG_PROXY_PATH,
});

// will need to use a different proxy path depending on which app is using the widget
let requestClient = requester({
  proxyPath: 'rental-manager/proxy/',
});

let logger: ErrorLoggerType = {
  error: (formattedError: FormatForLogType, message: string) => console.error(formattedError, message), // eslint-disable-line no-console
};

const PMRWidget = (props: PMRWidgetPropsType) => {
  const { appLogger } = props;

  if (appLogger) {
    logger = appLogger;
  }

  if (props.requestClient) {
    requestClient = props.requestClient;
  }

  if (props.rentalGrowthClient) {
    growthRequestClient = props.rentalGrowthClient;
  }

  return (
    <Provider store={store}>
      <PriceMyRental {...props} />
    </Provider>
  );
};

export { logger };
export { requestClient, growthRequestClient };
export default PMRWidget;
